<template>
  <div>
    <modal v-model:show="errors.length" modal-classes="modal-danger" modal-content-classes="bg-gradient-danger">
      <template v-slot:header>
        <h6 class="modal-title">{{ $t($route.name + '.errorsModalTitle') }}</h6>
      </template>

      <div class="py-3 text-center">
        <i class="ni ni-support-16 ni-3x"></i>
        <h4 class="heading mt-4">{{ $t($route.name + '.errorsModalBodyTitle') }}</h4>
        <ul v-for="error in errors" :key="error">
          <li>{{ error }}</li>
        </ul>
      </div>

      <template v-slot:footer>
        <base-button type="link" class="text-white ml-auto" v-on:click="errors = []">{{ $t($route.name +
          '.errorsModalCloseButton') }}</base-button>
      </template>
    </modal>
    <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0" v-if="terrain_front_data.terrain_selected != 'new_terrain_selected'">
              {{ $t(this.$route.name + '.terrainsDetailsTitle', { terrain_name: terrain_front_data.terrain_selected }) }}
            </h3>
            <h3 class="mb-0" v-else>
              {{ $t(this.$route.name + '.terrainsDetailsNewTerrainTitle') }}
            </h3>
          </div>
        </div>
      </div>

      <div class="card-body" id="card-body-custom">
        <div class="row" id="terrain-report" v-if="terrain_front_data.terrain_selected != 'new_terrain_selected'">
          <div class="col">
            <ReportRequest :terrain_id="terrain_model.id" />
          </div>


        </div>

        <div class="row" id="row-terrain-body">
          <div class="col">
            <div v-if="terrain_front_data.terrain_selected != ''">
              <div id="terrain-details">
                <div class="nav-wrapper">
                  <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
                    <li class="nav-item">
                      <div v-if="terrain_front_data.selected_nav == 'profile'">
                        <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-1" aria-selected="true"
                          v-on:click="onTerrainNavButtonsClick('profile')">{{
                            $t(this.$route.name + '.profileNavButton')
                          }}</a>
                      </div>
                      <div v-else>
                        <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-1" aria-selected="true"
                          v-on:click="onTerrainNavButtonsClick('profile')">{{
                            $t(this.$route.name + '.profileNavButton')
                          }}</a>
                      </div>
                    </li>
                    <li class="nav-item">
                      <div v-if="terrain_front_data.selected_nav == 'report'">
                        <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-1" aria-selected="true"
                          v-on:click="onTerrainNavButtonsClick('report')">{{
                            $t(this.$route.name + '.reportNavButton')
                          }}</a>
                      </div>
                      <div v-else>
                        <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-1" aria-selected="true"
                          v-on:click="onTerrainNavButtonsClick('report')">{{
                            $t(this.$route.name + '.reportNavButton')
                          }}</a>
                      </div>
                    </li>
                    <li class="nav-item">
                      <div v-if="terrain_front_data.selected_nav == 'plots'">
                        <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-3-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-3" aria-selected="false"
                          v-on:click="onTerrainNavButtonsClick('plots')">{{ $t(this.$route.name + '.plotsNavButton')
                          }}</a>
                      </div>
                      <div v-else>
                        <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-3-tab" data-toggle="tab" role="tab"
                          aria-controls="tabs-icons-text-3" aria-selected="false"
                          v-on:click="onTerrainNavButtonsClick('plots')">{{ $t(this.$route.name + '.plotsNavButton')
                          }}</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="card shadow">
                  <div class="card-body">
                    <form role="form" v-on:submit.prevent="handleUpdateTerrain">
                      <div v-if="terrain_front_data.selected_nav == 'profile'">
                        <!-- Terrain profile -->
                        <!-- Terrain name -->
                        <div class="row">
                          <div class="col">


                            <span>{{ $t($route.name + '.terrainName') }}</span>

                            <Popper arrow class="light" :content="$t($route.name + '.terrainNameInfoPopover')">
                              <a type="button"><i class="ni ni-bulb-61"></i></a>
                            </Popper>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group" :class="{ error: v$.terrain_model.name.$errors.length }">
                              <base-input formClasses="input-group-alternative" type="text"
                                v-model="v$.terrain_model.name.$model"
                                :error="errorsArrayToSingleString(v$.terrain_model.name.$errors)"
                                :placeholder="$t($route.name + '.terrainNamePlaceholder')">
                              </base-input>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <span>{{ $t($route.name + '.terrainGoogleAskAddress') }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <GMapAutocomplete class="input-group"
                              :placeholder="$t($route.name + '.terrainGoogleAskAddressPlaceholder')"
                              @place_changed="setPlace" :options="{ types: ['address'] }">
                            </GMapAutocomplete>
                          </div>
                        </div>
                        <br>


                        <!-- Address street and number -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressStreet') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressStreetInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    v-model="v$.terrain_model.address.street.$model"
                                    :placeholder="$t($route.name + '.terrainAddressStreetPlaceholder')"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.street.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressNumber') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressNumberInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.address.number.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="number" min="0"
                                    v-model="v$.terrain_model.address.number.$model"
                                    :placeholder="$t($route.name + '.terrainAddressNumberPlaceholder')"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.number.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Municipality and municipality code -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressMunicipality') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressMunicipalityInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.address.municipality.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    v-model="v$.terrain_model.address.municipality.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.municipality.$errors)"
                                    :placeholder="$t($route.name + '.terrainAddressMunicipalityPlaceholder')">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressMunicipalityCode') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressMunicipalityCodeInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.address.municipality_code.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="number" min="0"
                                    v-model="v$.terrain_model.address.municipality_code.$model"
                                    :placeholder="$t($route.name + '.terrainAddressMunicipalityCodePlaceholder')"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.municipality_code.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Province and postal code -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressProvince') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressProvinceInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.address.province.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    v-model="v$.terrain_model.address.province.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.province.$errors)"
                                    :placeholder="$t($route.name + '.terrainAddressProvincePlaceholder')">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressPostalCode') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressPostalCodeInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.address.postal_code.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="number" min="0"
                                    :placeholder="$t($route.name + '.terrainAddressPostalCodePlaceholder')"
                                    v-model="v$.terrain_model.address.postal_code.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.postal_code.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Region and country -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressCountry') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressCountryInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    :placeholder="$t($route.name + '.terrainAddressCountryPlaceholder')"
                                    v-model="v$.terrain_model.address.country.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.country.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainAddressRegion') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainAddressRegionInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    :placeholder="$t($route.name + '.terrainAddressRegionPlaceholder')"
                                    v-model="v$.terrain_model.address.region.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.address.region.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- Topography - Area and elevation -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainArea') }}</span>
                                <Popper arrow class="light" :content="$t($route.name + '.terrainAreaInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                    step="0.001" min="0.000" v-model="v$.terrain_model.topography.area.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.topography.area.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainElevation') }}</span>
                                <Popper arrow class="light" :content="$t($route.name + '.terrainElevationInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div class="form-group">
                                  <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                    step="0.001" min="0.000" v-model="v$.terrain_model.topography.elevation.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.topography.elevation.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Homogeneous growing area and coordinates -->
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <span>{{ $t($route.name + '.terrainHomogeneousGrowingArea') }}</span>
                                <Popper arrow class="light"
                                  :content="$t($route.name + '.terrainHomogeneousGrowingAreaInfoPopover')">
                                  <a type="button"><i class="ni ni-bulb-61"></i></a>
                                </Popper>
                              </div>
                              <div class="col">
                                <div class="form-group"
                                  :class="{ error: v$.terrain_model.homogeneous_growing_area.$errors.length }">
                                  <base-input formClasses="input-group-alternative" type="text"
                                    :placeholder="$t($route.name + '.terrainHomogeneousGrowingAreaPlaceholder')"
                                    v-model="v$.terrain_model.homogeneous_growing_area.$model"
                                    :error="errorsArrayToSingleString(v$.terrain_model.homogeneous_growing_area.$errors)">
                                  </base-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row">
                              <div class="col">
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.terrainCoordinates') }}</span>
                                    <Popper arrow class="light"
                                      :content="$t($route.name + '.terrainCoordinatesInfoPopover')">
                                      <a type="button"><i class="ni ni-bulb-61"></i></a>
                                    </Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group"
                                      :class="{ error: v$.terrain_model.coordinates.$errors.length }">
                                      <base-input formClasses="input-group-alternative" type="text"
                                        :placeholder="$t($route.name + '.terrainCoordinatesPlaceholder')"
                                        v-model="v$.terrain_model.coordinates.$model"
                                        :error="errorsArrayToSingleString(v$.terrain_model.coordinates.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End of Terrain profile -->
                      <!-- Terrain report data -->
                      <div v-else-if="terrain_front_data.selected_nav == 'report'">
                        <div class="row">
                          <div class="col">
                            <span>{{ $t($route.name + '.reportFrequency') }}</span>
                            <Popper arrow class="light" :content="$t($route.name + '.terrainFrequencyInfoPopover')">
                              <a type="button"><i class="ni ni-bulb-61"></i></a>
                            </Popper>
                          </div>
                          <div class="col">
                            <select v-model="terrain_model.report.frequency">
                              <option disabled v-for="frequency of report_frequencies" :key=frequency
                                v-bind:value="frequency">
                                {{ $t($route.name + '.' + frequency) }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <span>{{ $t($route.name + '.reportLatestSent') }}</span>
                          </div>
                          <div class="col">
                            <div class="form-group">
                              <base-input formClasses="input-group-alternative" disabled type="text"
                                v-model="last_sent_datetime">
                              </base-input>
                            </div>
                          </div>
                        </div>
                        <hr>
                        <div class="row">
                          <div class="col">
                            <span>{{ $t($route.name + '.reportEmails') }}</span>
                            <Popper arrow class="light" :content="$t($route.name + '.terrainEmailsInfoPopover')">
                              <a type="button"><i class="ni ni-bulb-61"></i></a>
                            </Popper>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group" :class="{ error: v$.report_emails.email_1.$errors.length }">
                              <base-input formClasses="input-group-alternative" type="text"
                                :placeholder="$t($route.name + '.terrainReportEmailPlaceholder')"
                                v-model="v$.report_emails.email_1.$model"
                                :error="errorsArrayToSingleString(v$.report_emails.email_1.$errors)">
                              </base-input>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group" :class="{ error: v$.report_emails.email_2.$errors.length }">
                              <base-input formClasses="input-group-alternative" type="text"
                                :placeholder="$t($route.name + '.terrainReportEmailPlaceholder')"
                                v-model="v$.report_emails.email_2.$model"
                                :error="errorsArrayToSingleString(v$.report_emails.email_2.$errors)">
                              </base-input>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group" :class="{ error: v$.report_emails.email_3.$errors.length }">
                              <base-input formClasses="input-group-alternative" type="text"
                                :placeholder="$t($route.name + '.terrainReportEmailPlaceholder')"
                                v-model="v$.report_emails.email_3.$model"
                                :error="errorsArrayToSingleString(v$.report_emails.email_3.$errors)">
                              </base-input>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End of Terrain report data -->
                      <!-- Terrain plot list -->
                      <div v-else-if="terrain_front_data.selected_nav == 'plots'">
                        <div v-if="terrain_model.plots.length">
                          <div class="table-responsive">
                            <a type="button" v-on:click="onAddNewPlot()">
                              <i class="ni ni-fat-add text-blue"></i>
                              <span class="text-blue">{{ $t($route.name + '.terrainPlotAddNew') }}</span>
                            </a>
                            <br>
                            <base-table thead-classes="thead-light" :data="terrain_model.plots">
                              <template v-slot:columns>
                                <th>{{ $t($route.name + '.terrainPlotNameHeader') }}</th>
                                <th>{{ $t($route.name + '.terrainPlotActionHeader') }}</th>
                                <th>{{ $t($route.name + '.terrainPlotCropTypeHeader') }}</th>
                                <th>{{ $t($route.name + '.terrainPlotAreaHeader') }}</th>
                                <th>{{ $t($route.name + '.terrainPlotSigpacCodeHeader') }}</th>
                              </template>

                              <template v-slot:default="row">
                                <th scope="row">
                                  {{ row.item.name }}
                                </th>
                                <td>
                                  <a type="button" v-on:click="onModifyPlot(row.item.id)">
                                    <i class="ni ni-settings-gear-65 text-blue fa-2x"></i>
                                  </a>
                                </td>
                                <td>
                                  {{ row.item.params.crop.crop_type }}
                                </td>
                                <td>
                                  {{ row.item.params.plot_area }}
                                </td>
                                <td>
                                  {{ row.item.params.sigpac_code }}
                                </td>
                              </template>
                            </base-table>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ $t($route.name + '.terrainPlotNoPlotInList') }}</span>
                          <br>
                          <a type="button" v-on:click="onAddNewPlot()"> 
                            <i class="ni ni-fat-add text-blue"></i>
                            <span class="text-blue">{{ $t($route.name + '.terrainPlotAddNew') }}</span>
                          </a>
                        </div>
                      </div>
                      <br>
                      <!-- Terrain form submit buttons -->
                      <div class="row">
                        <button class="btn btn-icon btn-primary" type="submit">
                          <div v-if="terrain_front_data.terrain_selected == 'new_terrain_selected'">
                            <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
                            <span class="btn-inner--text">{{ $t($route.name + '.terrainNewTerrainButton') }}</span>
                          </div>
                          <div v-else>
                            <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
                            <span class="btn-inner--text">{{ $t($route.name + '.terrainUpdate') }}</span>
                          </div>
                        </button>
                        <button type="button" class="btn btn-outline-default" v-on:click="resetTerrainFields()">
                          {{ $t($route.name + '.terrainRestore') }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TerrainService from '@/services/terrain.service.js';
import LandlordService from '@/services/landlord.service.js';

import TerrainModel from '@/views/Terrains/terrain.model.js'

import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers, minValue, email } from '@vuelidate/validators'
import ReportRequest from '@/views/Terrains/ReportRequest.vue';

const report_frequencies_list = ["daily", "weekly", "monthly", "yearly"]
const coordinates_regex = helpers.regex(/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/)

export default {
  name: "terrain-details",
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      terrain_model: {
        name: {
          required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
          min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "6" }), minLength(6)),
          valid_name: helpers.withMessage(this.$t(this.$route.name + ".errorNameAlreadyExists"), this.checkIfTerrainNameAlreadyExists),
        },
        homogeneous_growing_area: {
          required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
          min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "6" }), minLength(6)),
        },
        coordinates: {
          required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
          coord_regex: helpers.withMessage(this.$t(this.$route.name + ".errorCoordinatesIncorrect"), coordinates_regex),
        },
        topography: {
          area: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + ".errorNegativeNumber"), minValue(0)),
          },
          elevation: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + ".errorNegativeNumber"), minValue(0)),
          },
        },
        address: {
          street: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "3" }), minLength(3)),
          },
          number: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + ".errorNegativeNumber"), minValue(0)),
          },
          municipality: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "3" }), minLength(3)),
          },
          municipality_code: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + ".errorNegativeNumber"), minValue(0)),
          },
          region: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "3" }), minLength(3)),
          },
          province: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "3" }), minLength(3)),
          },
          postal_code: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + ".errorNegativeNumber"), minValue(0)),
          },
          country: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + ".errorFieldRequired"), required),
            min: helpers.withMessage(this.$t(this.$route.name + ".errorInvalidLength", { length: "3" }), minLength(3)),
          },
        },
      },
      report_emails: {
        email_1: {
          email_custom: helpers.withMessage(this.$t(this.$route.name + ".errorEmailInvalid"), email),
        },
        email_2: {
          email_custom: helpers.withMessage(this.$t(this.$route.name + ".errorEmailInvalid"), email),
        },
        email_3: {
          email_custom: helpers.withMessage(this.$t(this.$route.name + ".errorEmailInvalid"), email),
        }
      }
    };
  },
  props: {
    terrainId: String
  },
  created() {
    var landlord = JSON.parse(localStorage.getItem("landlord"));
    this.landlord = landlord;

    const terrainId = ((this.terrainId == '') || (this.terrainId == null)) ? "new_terrain_selected" : this.terrainId;
    if (terrainId == "new_terrain_selected") {
      this.terrain_model = JSON.parse(JSON.stringify(TerrainModel.terrain_read_model));
      this.terrain_original = JSON.parse(JSON.stringify(TerrainModel.terrain_read_model));
      this.report_emails.email_1 = "";
      this.report_emails.email_2 = "";
      this.report_emails.email_3 = "";
      this.last_sent_datetime = "";
      this.terrain_front_data.terrain_selected = "new_terrain_selected"
    }
    else {
      this.terrain_front_data.terrain_selected = terrainId
      TerrainService.getTerrainById(terrainId).then(terrain => {
        this.terrain_model = terrain;
        this.terrain_original = JSON.parse(JSON.stringify(terrain));
        this.last_sent_datetime = this.convertISODatetime(this.terrain_model.report.last_sent_datetime);
        if (this.terrain_model.report.emails != null) {
          Object.values(this.terrain_model.report.emails).forEach(email => {
            Object.keys(this.report_emails).every(key => {
              if (email != "" && this.report_emails[key] == "") {
                this.report_emails[key] = email;
                return false;
              }
              return true;
            });
          });
        }
      });
    }
  },
  data() {
    return {
      terrain_front_data: {
        terrain_selected: "",
        selected_nav: "profile",
      },
      terrain_model: TerrainModel.terrain_read_model,
      landlord: null,
      terrain_original: TerrainModel.terrain_read_model,
      report_frequencies: report_frequencies_list,
      last_sent_datetime: "",
      errors: [],
      report_emails: {
        email_1: "",
        email_2: "",
        email_3: ""
      }
    };
  },
  methods: {
    setPlace(place) {
      var lat = place.geometry.location.lat();
      var lng = place.geometry.location.lng();
      this.terrain_model.address.street = place.address_components[0].long_name;
      this.terrain_model.address.municipality = place.address_components[1].long_name;
      this.terrain_model.address.province = place.address_components[2].long_name;
      this.terrain_model.address.region = place.address_components[3].long_name;
      this.terrain_model.address.country = place.address_components[4].long_name;
      if (place.address_components.length == 6) {
        this.terrain_model.address.postal_code = place.address_components[5].long_name;
      }
      this.terrain_model.coordinates = String(lat) + ", " + String(lng);
    },
    handleUpdateTerrain() {
      // Check all validators
      this.v$.$touch();
      if (this.v$.terrain_model.$invalid) {
        if (this.v$.terrain_model.address.$invalid) {
          this.terrain_front_data.selected_nav = "profile";
          this.errors.push(this.$t(this.$route.name + ".errorProfileFieldsLeft"));
          return;
        }
      }
      if (this.v$.report_emails.$invalid) {
        this.terrain_front_data.selected_nav = "report";
        this.errors.push(this.$t(this.$route.name + ".errorReportFieldsLeft"));
        return;
      }
      this.terrain_model.report.emails = [];
      Object.values(this.report_emails).forEach(email => {
        if (email != "") {
          this.terrain_model.report.emails.push(email);
        }
      });
      // Getting here means all fields of the form are correct
      if (this.terrain_front_data.terrain_selected == "new_terrain_selected") {
        // create new terrain id
        const terrain_id = this.terrain_model.name.replaceAll(" ", "_");
        this.terrain_model.id = terrain_id;
        this.terrain_model.landlord_id = this.landlord.id;
        this.terrain_model.report.last_sent_datetime = this.convertISODatetimeToUTCStd(new Date().toISOString());
        // Create terrain service
        TerrainService.createTerrain(this.terrain_model).then(() => {
          // Terrain created successfully, update local data
          LandlordService.getLandlordAllDataById(this.landlord.id).then(landlord => {
            localStorage.setItem("landlord", JSON.stringify(landlord));
            // Reload the page to refresh data
            this.$router.push({ name: 'terrains' });
          }, error => {
            console.log(error)
          });
        }, error => {
          console.log(error)
        });
      }
      else {
        // update model data
        TerrainService.updateTerrainById(this.terrain_model.id, this.terrain_model).then(() => {
          TerrainService.updateTerrainReportById(this.terrain_model.id, this.terrain_model).then(() => {
            // Terrain created successfully, update local data
            LandlordService.getLandlordAllDataById(this.landlord.id).then(landlord => {
              localStorage.setItem("landlord", JSON.stringify(landlord));
              // Reload the page to refresh data
              this.$router.push({ name: 'terrains' });
            }, error => {
              console.log(error)
            });
          });
        }, error => {
          console.log(error)
        });
      }
    },
    onTerrainNavButtonsClick(nav_item) {
      this.terrain_front_data.selected_nav = nav_item;
    },
    resetTerrainFields() {
      this.terrain_model = JSON.parse(JSON.stringify(this.terrain_original));
      this.last_sent_datetime = this.convertISODatetime(this.terrain_model.report.last_sent_datetime);
      this.report_emails.email_1 = "";
      this.report_emails.email_2 = "";
      this.report_emails.email_3 = "";
      if (this.terrain_model.report.emails != null) {
        Object.values(this.terrain_model.report.emails).forEach(email => {
          Object.keys(this.report_emails).every(key => {
            if (email != "" && this.report_emails[key] == "") {
              this.report_emails[key] = email;
              return false;
            }
            return true;
          });
        });
      }
    },
    errorsArrayToSingleString(array) {
      var str = "";
      if (array.length == 0)
        return;
      array.forEach(item => str += item.$message + "\n");
      return str;
    },
    checkIfTerrainNameAlreadyExists(name) {
      // return true if doesn't exists and false if it does
      return this.landlord.terrains.filter(terrain => terrain.name === name).length == 0;
    },
    convertISODatetime(iso_datetime) {
      // return a human readable datetime
      if (iso_datetime == "")
        return iso_datetime;
      var date_split = iso_datetime.split("T");
      var date = date_split[0];
      var time = date_split[1].split(".")[0];
      return date + " " + time + " (UTC)";
    },
    convertISODatetimeToUTCStd(iso_datetime) {
      // return a human readable datetime
      if (iso_datetime == "")
        return iso_datetime;
      var date_split = iso_datetime.split("T");
      var date = date_split[0];
      var time = date_split[1].split(".")[0];
      return date + "T" + time;
    },
    onAddNewPlot() {
      localStorage.setItem('plotId', '')
      this.$router.push({ name: 'plot_manager' })
    },
    onModifyPlot(plotId) {
      localStorage.setItem('plotId', plotId)
      this.$router.push({ name: 'plot_manager' })
    }
  },
  components: { ReportRequest }
};
</script>
<style>
.divider {
  font-size: 1px;
  background: rgba(0, 0, 0, 0.5);
}
</style>
